import * as THREE from 'three'

import Experience from '../Experience.js'
import LightBox from './LightBox.js'
import Stars from './Stars.js'
import Astro from './Astro.js'

export default class World
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        this.objects = []
        this.group = new THREE.Group()

        let uniform = false
        const monochrome = $fx.rand() > 0.9
        console.log(monochrome)
        if(monochrome) {
            this.hue = Math.floor($fx.rand() * 360)
            uniform = $fx.rand() > 0.5
        }

        // Wait for resources
        this.resources.on('ready', () =>
        {
            // Setup
            
            let xBound = Math.floor($fx.rand() * 4) + 1
            let yBound = Math.floor($fx.rand() * 4) + 1
            let zBound = Math.floor($fx.rand() * 4) + 1

            for(let x = -xBound; x <= xBound; x++) {
                for(let y = -yBound; y <= yBound; y++) {
                    for(let z = -zBound; z <= zBound; z++) {
                        if($fx.rand() > 0.4)
                            this.objects.push(new LightBox(x, y, z, monochrome ? this.hue : Math.floor($fx.rand() * 256), monochrome ? 50 : 85, uniform))
                    }
                }
            }

            this.objects.forEach(object => {
                this.group.add(object.getSceneObject()) 
            });
            this.scene.add(this.group)

            this.astro = new Astro()

            this.stars = new Stars()
        })
    }

    update()
    {
        if(this.objects.length > 8) {
            this.objects.forEach(object => {
                if(object instanceof LightBox) {
                    object.update(1)
                }
            })
        }
        
        this.group.rotateX(0.001)
        this.group.rotateY(0.001)

        if(this.astro)
            this.astro.update()

        if(this.stars)
            this.stars.update()
    }
}